import { Navigate } from "react-router-dom";

import Contact from "../../pages/public/Contact";

//--------Staff-------
import StaffLogin from "../../pages/staff/auth/StaffLogin";
import ContactPage from "../../pages/public/ContactPage/Contact";
import EPCMPage from "../../pages/public/EPCMPage/EPCM";
import SoftwarePage from "../../pages/public/SoftwarePage/Software";
import LandingPage from "../../pages/public/LandingPage/LandingPage";
import DemoPage from "../../pages/public/guest/demoPage";
import { demoVideoJSON } from "../../pages/public/guest/demoPage/demoVideos";
import { onBoardinfVideosJSON } from "../../pages/public/guest/demoPage/onBoardingVideos";

export const mainRoutes = [
  // {
  //   index: true,
  //   element: <Navigate to="/home" />,
  // },
  {
    path: "/home",
    element: <LandingPage />,
  },
  {
    path: "/home/contact",
    element: <ContactPage />,
  },
  {
    path: "/home/epcm",
    element: <EPCMPage />,
  },
  {
    path: "/home/software",
    element: <SoftwarePage />,
  },
  {
    path: "/home/demo",
    element: <DemoPage videoData={demoVideoJSON} />,
  },
  {
    path: "/home/onboarding",
    element: <DemoPage videoData={onBoardinfVideosJSON} />,
  },
];
